/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import {
    Flex,
    Heading,
    IconPlusCircle,
    Text,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

// awesome styled grid
import {
    Container,
    Row,
    Link,
} from '@zillow/zrs-comet';

// vars
const maxSearchBoxWidth = '370px';

export const StyledHeadingContainer = styled(Container)`
    .PropertiesPage-heading-col {
        flex-basis: unset;
    }

    .PropertiesPage-heading-col-addproperty {
        /* 768 */
        ${mediaMixin('md', css`
            margin-right: ${spaceMixin('sm')};
        `)}
    }
`;

export const StyledHeading = styled(Heading)`
    ${props => props.theme.ns().spacing.getSpacingMixin()};
`;

export const StyledFlexContainer = styled(Flex)`
    flex-direction: column;
    min-height: 94px;
    background: ${props => props.theme.ns().colors.white};
    border: solid 1px ${props => props.theme.ns().colors.gray200};
    border-radius: 3px;

    /* 768 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
            flex-direction: row;
            justify-content: space-between;
        `)};

    /* 768 */
    .SubHeadingSection-Summary {
        align-self: flex-start;
        margin-bottom: ${spaceMixin('sm')};
        line-height: 16px;
        text-align: left;

        /* 768 */
        ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
            align-self: center;
            margin-bottom: 0;
        `)};
    }

    .SearchBox {
        margin: unset;

        /* 768 */
        ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
            max-width: ${maxSearchBoxWidth};
        `)};
    }
`;

export const StyledSearchBoxContainer = styled.div`
    width: 100%;

    /* 768 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg - 1}px)`, css`
        max-width: 370px;
    `)};
`;

export const StyledRow = styled(Row)`
    ${props => props.theme &&
        props.theme.ns && css`
            height: 94px;
            background: ${props.theme.ns().colors.white};
            border: solid 1px ${props.theme.ns().colors.gray200};

            ${props.theme.ns().media.getMediaQuery('(min-width: 1rem)', css`
                /* margin: 0; */
                .SubHeadingSection-Summary {
                    text-align: center;
                }

                .SubHeadingSection-Search {
                    margin: 0 auto;
                    width: 100%;
                }
            `)};

            /* 768 */
            ${props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.foundation.media.BREAKPOINTS.lg - 1}px)`, css`
                padding-left: 0.5rem;
                padding-right: 0.5rem;

                .SubHeadingSection-Summary {
                    text-align: left;
                }

                .SubHeadingSection-SearchBox-Col {
                    align-items: flex-end;
                }

                .SubHeadingSection-SearchBox {
                    margin: unset;
                    width: 370px;
                }
            `)};

            /* 1440px */
            ${props.theme.ns().media.getMediaQuery('(min-width: 90rem)', css`
                padding-left: 0.75rem;
                padding-right: 0.75rem;
            `)};
        `}
`;

/* did not extend Col for more control of the layout */
export const StyledSubHeadingSectionBox = styled.div`
    ${props => props.theme.ns().spacing.getSpacingMixin()};

    display: flex;
    flex-direction: 'row';
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: ${props => props.theme.ns().colors.white};
`;

export const StyledLink = styled(Link)`
    display: flex;
    align-items: center;

    &:hover {
        svg {
            /* 769 */
            ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.lg}px)`, css`
                color: ${props => props.theme.ns().colors.blue300};
            `)};
        }
    }
`;

export const StyledIconPlusCircle = styled(IconPlusCircle)`
    ${props => props.theme &&
        props.theme.ns && css`
            margin-right: ${props.theme.ns().spacing.xs()};
            color: ${props => props.theme.ns().colors.blue400};

            width: 24px;
            height: 24px;
        `}
`;

export const StyledInheritText = styled(Text)`
    /* 0 */
    ${props => props.theme.ns().media.getMediaQuery(`(min-width: ${props.theme.ns().media.BREAKPOINTS.xs}px)`, css`
        color: inherit;
        font-weight: 600;
        line-height: unset;
    `)};
`;
